// @ts-expect-error App isn't typed yet
import App from './App';
new App().start();